import { render, staticRenderFns } from "./PrioridadesView.vue?vue&type=template&id=5032cd4d&"
import script from "./PrioridadesView.vue?vue&type=script&lang=js&"
export * from "./PrioridadesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports